module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-01-m-jp.f3308d08138baaef58517f91db8bbe44.png";